import { useEffect } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { ShieldCheck, Users, UserCheck, Car, MapPin, CalendarCheck, Flag, CreditCard, BarChart3, LifeBuoy, Star, ScrollText, Megaphone, Gift, Percent, Building2, Settings, Trash2, FileCheck } from "lucide-react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import { setPageTitle } from "../../lib/format";

const NAV = [
  ["", "Overview", ShieldCheck],
  ["users", "Users", Users],
  ["hosts", "Hosts", UserCheck],
  ["drivers", "Drivers", Car],
  ["listings", "Listings", MapPin],
  ["bookings", "Bookings", CalendarCheck],
  ["reports", "Reports", Flag],
  ["payments", "Payments", CreditCard],
  ["analytics", "Analytics", BarChart3],
  ["promotions", "Rewards", Gift],
  ["commission", "Commission", Percent],
  ["commercial", "Commercial", Building2],
  ["tickets", "Tickets", LifeBuoy],
  ["reviews", "Reviews", Star],
  ["audit", "Audit", ScrollText],
  ["broadcast", "Broadcast", Megaphone],
  ["settings", "Settings", Settings],
  ["deletions", "Deletions", Trash2],
  ["consents", "Consents", FileCheck],
];

export default function AdminLayout() {
  useEffect(() => setPageTitle("Admin"), []);
  return (
    <div className="min-h-screen flex flex-col" data-testid="admin-page">
      <Navbar />
      <main className="flex-1 max-w-7xl w-full mx-auto px-5 sm:px-8 pt-28 pb-16">
        <p className="section-label">Administration</p>
        <h1 className="type-display mt-3">Admin</h1>
        <nav className="mt-6 flex gap-2 overflow-auto pb-1" aria-label="Admin sections">
          {NAV.map(([v, l, Icon]) => (
            <NavLink key={v || "overview"} to={v ? `/admin/${v}` : "/admin"} end={!v}
              data-testid={`admin-nav-${v || "overview"}`}
              className={({ isActive }) => `px-4 py-2 rounded-full text-xs font-semibold border whitespace-nowrap transition-colors inline-flex items-center gap-1.5 ${isActive ? "bg-[#E50914] border-[#E50914] text-white" : "bg-[#1F2328] border-[#27272A] text-zinc-300 hover:border-[#3F3F46]"}`}>
              <Icon className="w-3.5 h-3.5" />{l}
            </NavLink>
          ))}
        </nav>
        <div className="mt-6"><Outlet /></div>
      </main>
      <Footer />
    </div>
  );
}
